/* eslint-disable no-unsafe-optional-chaining */
import * as idb from "idb";
import { parseTemplateData, parseTemplateTextContent } from "./utils";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";
import { AES, enc } from "crypto-js";
import API from "../../api/api/API";
const SECRET_KEY = 'g/RdlVZYBS2BWL/TZL68e1eNUXYT0PcEMXErTZHMvktEJwLVCXfc2TNSiR7YckcGlFo=v';


function setlocalstorage() {
  localStorage.setItem('userData', JSON.stringify({ "data": { "configs": { "ner": { "currentOption": { "label": "Retain", "value": "retain" }, "id": "ner", "name": "Named Entities", "options": [{ "label": "Retain", "value": "retain" }, { "label": "Convert", "value": "convert" }] }, "other": { "currentOption": { "label": "Retain", "value": "retain" }, "id": "other", "name": "Other Entities", "options": [{ "label": "Retain", "value": "retain" }, { "label": "Convert", "value": "convert" }] }, "salutation": { "currentOption": { "label": "Retain", "value": "retain" }, "id": "salutation", "name": "Salutation", "options": [{ "label": "Retain", "value": "retain" }, { "label": "Convert", "value": "convert" }, { "label": "Translate", "value": "translate" }] } }, "firstName": "kaikala", "language_types": { "options": [{ "label": "Assamese", "value": "as" }, { "label": "Bengali", "value": "bn" }, { "label": "English", "value": "en" }, { "label": "Gujarati", "value": "gu" }, { "label": "Hindi", "value": "hi" }, { "label": "Kannada", "value": "kn" }, { "label": "Malayalam", "value": "ml" }, { "label": "Manipuri", "value": "mn" }, { "label": "Marathi", "value": "mr" }, { "label": "Odia", "value": "or" }, { "label": "Punjabi", "value": "pa" }, { "label": "Sindhi", "value": "sd" }, { "label": "Tamil", "value": "ta" }, { "label": "Telugu", "value": "te" }, { "label": "Urdu", "value": "ur" }] }, "lastName": "harish", "permission": { "manage_activity_log": true, "manage_batch_translation": true, "manage_corpus_feedback": true, "manage_doc_editor": true, "manage_doc_translation": true, "manage_file_conversion": true, "manage_glossary": true, "manage_organisation": true, "manage_role": true, "manage_text_translation": true, "manage_training_corpus": true, "manage_user": true, "manage_user_feedback": true, "permission_name": "Admin" }, "userID": 86, "user_agency": "NCERT", "user_agency_id": 1 }, "isAuth": true })
)}

setlocalstorage();


const INDEX_SCHEMA = {
  fingerprints: [{ pageid: "pageid" }, { mutated: "mutated" }],
  assets: [{ pageindex: "pageindex" }, { mutated: "mutated" }],
  metadata: [],
};

async function resetDB(db = null) {
  try {
    const stack = Object.keys(INDEX_SCHEMA)
      .filter((d) => db === null || d === db)
      .map(async (d) => {
        try {
          await idb.deleteDB(d);
        } catch (error) {
          console.error(`Failed to delete DB: ${d}`, error);
        }
      });

    await Promise.all(stack);
    localStorage.removeItem("document_id");
   
  } catch (error) {
    console.error("An error occurred during resetDB:", error);
  }
}



async function getDB(db, objectStore, version = 1) {
  return await idb.openDB(db, version, {
    upgrade(_db) {
      const store = _db.createObjectStore(objectStore);
      for (const index of INDEX_SCHEMA?.[db] || []) {
        const args = Object.entries(index || {})[0];
        if (!args) return;
        store.createIndex(...args);
      }
      localStorage.removeItem("document_id");
    },
  });
}

async function connect(database, objectStore, option = "readwrite") {
  const db = await getDB(database, objectStore, 1);
  const transaction = db.transaction(objectStore, option);
  return [transaction.objectStore(objectStore), db];
}

async function generateLookup(store) {
  const data = {};
  let cursor = await store.openCursor();
  while (cursor) {
    data[cursor.key] = cursor.value;
    cursor = await cursor.continue();
  }
  return data;
}

async function fetchPromise(id) {
  if (!id) return;
  const objectStore = localStorage.getItem("document_id");
  const userData = JSON.parse(localStorage.getItem("userData") || {});

  const apiCall = async () => {
    if (!("userID" in userData?.data || {})) return;
    const api = new API();
    const data = await api.call({
      cmd: "userAPI",
      path: "pdf/get_json",
      payload: { document_id: id, user_id: userData.data.userID },
    });

    await reSyncTo(data, id);

    localStorage.setItem("document_id", id);
    return data;
  };

  if (!objectStore || objectStore !== id) {
    return await apiCall();
  }
  const [metadata, db] = await connect("metadata", objectStore);
  const token = (await metadata.get("metadata"))?.token;
  await db.close();

  const existingMetadata = () => {
    try {
      return JSON.parse(AES.decrypt(token, SECRET_KEY).toString(enc.Utf8));
    } catch (err) {
      return {};
    }
  };
  if (
    userData.data.userID !== existingMetadata().userId ||
    userData.data.user_agency_id !== existingMetadata().orgId
  ) {
    await resetDB();
    return;
  }
  return await reSyncFrom(id);
}

async function fetch(id) {
  return await trackPromise(fetchPromise(id));
}

async function reSyncTo(data, objectStore) {
  await resetDB();
  const __objectStore = objectStore;

  const [metadata] = await connect("metadata", __objectStore);

  const userData = JSON.parse(localStorage.getItem("userData") || null);

  if (!userData) return;
  const encData = JSON.stringify({
    userId: userData.data.userID,
    orgId: userData.data.user_agency_id,
  });
  const token = AES.encrypt(encData, SECRET_KEY).toString();

  metadata.put(
    {
      lastactiontime: moment().unix(),
      name: data.name,
      size: data.size,
      token,
    },
    "metadata"
  );

  data.pages = data.pages.filter((d) => d);
  for (let i = 0; i < data.pages.length; i++) {
    const page = data.pages[i];
    const content = page.content;

    const [assets] = await connect("assets", __objectStore);
    assets.put(
      {
        data: page.layout,
        pageid: page.id,
        pageindex: i,
        size: data.size,
        mutated: 0,
      },
      page.id
    );

    for (let c of content) {
      const html = parseTemplateData(c.data);
      const textContent = parseTemplateTextContent(html);

      const sourceText = parseTemplateTextContent(
        parseTemplateData(c.data, "source_text")
      );

      const [fingerprint] = await connect("fingerprints", __objectStore);
      fingerprint.put(
        {
          id: c.id,
          pageid: page.id,
          html: html,
          text: textContent,
          sourceText,
          originalText: textContent,
          position: c.position,
          color: c.style.color,
          width: c.style.width,
          height: c.style.height,
          fontSize: c.style.size,
          mutated: 0,
          action: "none",
        },
        c.id
      );
    }
  }
}

async function reSyncFrom(objectStore) {
  const data = {
    id: objectStore,
    pages: [],
  };
  const [metadata] = await connect("metadata", objectStore);
  const metadataObj = await metadata.get("metadata");
  data.name = metadataObj.name || "cached data";

  function contentFrom(content = []) {
    return content.map((c) => ({
      id: c.id,
      data: [
        {
          source_text: c.sourceText,
          text: c.html,
          type: "text",
        },
      ],
      position: c.position,
      style: {
        color: c.color,
        width: c.width,
        height: c.height,
        size: c.fontSize,
      },
      action: c.action,
    }));
  }
  const [assets] = await connect("assets", objectStore);
  const assetsLookup = await generateLookup(assets);

  const [, db] = await connect("fingerprints", objectStore);
  for (const pageid in assetsLookup) {
    const { data: layout, action, pageindex, size } = assetsLookup[pageid];

    const content = await db.getAllFromIndex(objectStore, "pageid", pageid);
    data.pages[pageindex] = {
      id: pageid,
      content: contentFrom(content),
      layout,
      action,
    };
    data.size = size;
  }
  return data;
}

async function put(database, objectStore, value, key) {
  const [store] = await connect(database, objectStore);
  const existingValue = (await store.get(key)) || {};

  // let isSame = true;
  // for (let v in value) {
  //   if (v === "mutated") continue;
  //   console.log(existingValue?.[v], value[v], v);
  //   isSame &&= JSON.stringify(existingValue?.[v]) === JSON.stringify(value[v]);
  // }

  // if (isSame) return;
  return store.put({ ...existingValue, ...value }, key);
}

async function del(database, objectStore, key) {
  const [store] = await connect(database, objectStore);
  return store.delete(key);
}

async function clear(database, objectStore) {
  const [store] = await connect(database, objectStore);
  return store.clear();
}

async function get(database, objectStore, key) {
  const [, db] = await connect(database, objectStore);
  return await db.get(objectStore, key);
}

async function getAll(database, objectStore) {
  const [store] = await connect(database, objectStore);
  return await generateLookup(store);
}

async function getFromIndex(database, objectStore, key, query) {
  const [, db] = await connect(database, objectStore);
  return await db.getFromIndex(objectStore, key, query);
}

async function getAllFromIndex(database, objectStore, key, query) {
  const [, db] = await connect(database, objectStore);
  return await db.getAllFromIndex(objectStore, key, query);
}

async function delFromIndex(database, objectStore, indexName, key) {
  const [store] = await connect(database, objectStore);
  const index = store.index(indexName);
  let cursor = await index.openCursor(IDBKeyRange.only(key));

  while (cursor) {
    const { primaryKey } = cursor;
    await store.delete(primaryKey);
    cursor = await cursor.continue();
  }
}

const fingerprints = {
  put: (...args) => put("fingerprints", ...args),
  del: (...args) => del("fingerprints", ...args),
  delFromIndex: (...args) => delFromIndex("fingerprints", ...args),
  clear: (...args) => clear("fingerprints", ...args),
  getAll: (...args) => getAll("fingerprints", ...args),
  getFromIndex: (...args) => getFromIndex("fingerprints", ...args),
  getAllFromIndex: (...args) => getAllFromIndex("fingerprints", ...args),
};
const assets = {
  put: (...args) => put("assets", ...args),
  del: (...args) => del("assets", ...args),
  clear: (...args) => clear("assets", ...args),
  getAll: (...args) => getAll("assets", ...args),
  getFromIndex: (...args) => getFromIndex("assets", ...args),
  getAllFromIndex: (...args) => getAllFromIndex("assets", ...args),
};

const metadata = {
  put: (...args) => put("metadata", ...args),
  get: (...args) => get("metadata", ...args),
};

export default {
  getDB,
  fetch,
  reSyncTo,
  reSyncFrom,
  put,
  fingerprints,
  assets,
  metadata,
};
